export const products = [
    { id: "s1", name: "Glazing Milk", 
        brand: "Rhode", category: "Esencia", stock: true, ss:true,
        image: "https://i.pinimg.com/736x/75/a8/eb/75a8eb23ba5cbd7c68a3fee77537b403.jpg",
        tam: [
            { ml: 124, price: 1050, oldPrice: 940, image: "https://i.pinimg.com/736x/2d/17/90/2d17909a77ca6e80364f3028e8448ff8.jpg", },
            { ml: 65 , price: 700, oldPrice: 600, image: "https://i.pinimg.com/736x/43/4d/37/434d37c2e1102e98a395f006e30fec4f.jpg", }, 
        ],
        skinType: ["Todos los tipos"], concerns: ["Hidrata", "Prepara"],
        routine: "Esencia con ceramidas"
    },
    { id: "s2", name: "Niacinamida 10%", 
        brand: "The Ordinary", category: "Serum", stock: true, ss:true,
        image: "https://i.pinimg.com/736x/57/cb/69/57cb69013fa36b75b7f5cb61f2cac16c.jpg",
        tam: [
            { ml: 30, price: 270, oldPrice: 245, image: "", },
            { ml: 60 , price: 380, oldPrice: 355, image: "", }, 
        ],
        skinType: ["Todo tipo"], concerns: ["Reduce apariencia de poros", "Mejora la textura"],
        routine: "Combate opacidad,textura irregular y exceso de grasa"
    },
    { id: "s3", name: "Ácido Glicólico al 7%", 
        brand: "The Ordinary", category: "Tonico", stock: true, ss:true,
        image: "https://i.pinimg.com/736x/74/9b/ae/749baeb3941b8c7a6643505a9f9363dd.jpg",
        tam: [
            { ml: 100, price: 280, oldPrice: 250, image: "", },
            { ml: 240 , price: 360, oldPrice: 350, image: "", }, 
        ],
        skinType: ["Todos los tipos"], concerns: ["Mejorar el tono desigual", "Despingmentante"],
        routine: "Tónico exfoliante"
    },
    { id: "s4", name: "Ácido Salicilico 2%", 
        brand: "The Ordinary", category: "Serum", stock: true, ss:true,
        image: "https://i.pinimg.com/736x/60/4d/1b/604d1bc4b0f546fd5c406f3590a7ed00.jpg",
        tam: [
            { ml: 30, price: 295, oldPrice: 265, image: "", },
        ],
        skinType: ["Normal, Mixto y Gras"], concerns: ["Acné", "Reduce Rojeces"],
        routine: "Exfoliante combatir el acné"
    },
    { id: "s5", name: "Crema 345", 
        brand: "Dr Althea", category: "Crema", stock: true, ss:false,
        image: "",
        tam: [
            { ml: 1, price: 1, oldPrice: 1, image: "", },
            { ml: 1 , price: 1, oldPrice: 1, image: "", }, 
        ],
        skinType: [""], concerns: ["", ""],
        routine: ""
    },
    { id: "s6", name: "Ácido hialurónico 2% + B5", 
        brand: "The Ordinary", category: "Serum", stock: true, ss:true,
        image: "https://i.pinimg.com/736x/38/9a/26/389a2690444fd00a8c0f5720d758e97f.jpg",
        tam: [
            { ml: 30, price: 330, oldPrice: 300, image: "", },
            { ml: 60 , price: 560, oldPrice: 500, image: "", }, 
        ],
        skinType: ["Todos los tipos"], concerns: ["Sequedad"],
        routine: "Hidratante con ceramidas que rellena al instante"
    },
    { id: "s7", name: "Cleansing Oil", 
        brand: "", category: "", stock: false, ss:false,
        image: "",
        tam: [
            { ml: 1, price: 1, oldPrice: 1, image: "", },
            { ml: 1 , price: 1, oldPrice: 1, image: "", }, 
        ],
        skinType: [""], concerns: ["", ""],
        routine: ""
    },
    { id: "s8", name: "SOS Rescue Spray", 
        brand: "Tower 28", category: "Tónico", stock: false, ss:true,
        image: "https://i.pinimg.com/736x/17/f1/f0/17f1f07f3f9120013ffb8bb1b34bc3f2.jpg",
        tam: [
            { ml: 30, price: 440, oldPrice: 380, image: "https://www.sephora.com/productimages/sku/s2527836-main-zoom.jpg?imwidth=1224", },
            { ml: 120 , price: 880, oldPrice: 740, image: "https://www.sephora.com/productimages/sku/s2527844-main-zoom.jpg?imwidth=1224", }, 
            { ml: 480, price: 1885, oldPrice: 1750, image: "https://www.sephora.com/productimages/sku/s2617983-main-zoom.jpg?imwidth=1224", }, 
        ],
        skinType: ["Todos los tipos"], concerns: ["Desinfecta rostro", "Calma irritación","Uso tras ejercicio"],
        routine: "Tónico con ácido hipocloroso para reducir brotes"
    },
    { id: "s9", name: "Pineapple Refresh", 
        brand: "Rhode", category: "Limpiador", stock: true, ss:true,
        image: "https://www.sephora.com/productimages/sku/s2895829-av-2202508080840019270700-zoom.jpg?imwidth=1224",
        tam: [
            { ml: 150, price: 980, oldPrice: 860, image: "https://i.pinimg.com/736x/44/52/1c/44521c3e5a9ab8b6dc3fc09d7d5260dc.jpg", },
            { ml: 40 , price: 680, oldPrice: 580, image: "https://i.pinimg.com/736x/04/ab/91/04ab9145cd7e8bd81eb1e8a93c348411.jpg", }, 
        ],
        skinType: ["Todos los tipos"], concerns: ["Limpia y exfolia ", "PGA", "Ácido hialurónico"],
        routine: "Limpiador diario "
    },
    /*{ id: "s10", name: "", 
        brand: "", category: "", stock: false, ss:false,
        image: "",
        tam: [
            { ml: 1, price: 1, oldPrice: 1, image: "", },
            { ml: 1 , price: 1, oldPrice: 1, image: "", }, 
        ],
        skinType: [""], concerns: ["", ""],
        routine: ""
    },
    { id: "s11", name: "", 
        brand: "", category: "", stock: false, ss:false,
        image: "",
        tam: [
            { ml: 1, price: 1, oldPrice: 1, image: "", },
            { ml: 1 , price: 1, oldPrice: 1, image: "", }, 
        ],
        skinType: [""], concerns: ["", ""],
        routine: ""
    },**/
    { id: "s12", name: "Caffeine Solution 5% + EGCG ", 
        brand: "The Ordinary", category: "Serum", stock: true, ss:true,
        image: "https://i.pinimg.com/1200x/14/cf/f0/14cff0035fd97ea030f4d1bd251f81bf.jpg",
        tam: [
            { ml: 30, price: 350, oldPrice: 290, image: "", },
        ],
        skinType: ["Todo tipo"], concerns: ["Ojeras",],
        routine: "Combate ojeras e hinchazón alrededor de los ojos"
    },
    /*{ id: "s13", name: "", 
        brand: "", category: "", stock: false, ss:false,
        image: "",
        tam: [
            { ml: 1, price: 1, oldPrice: 1, image: "", },
            { ml: 1 , price: 1, oldPrice: 1, image: "", }, 
        ],
        skinType: [""], concerns: ["", ""],
        routine: ""
    },*/
    { id: "s14", name: "Peptide Glazing Fluid Serum", 
        brand: "Rhode", category: "Serum", stock: false, ss:true,
        image: "https://i.pinimg.com/736x/ec/c2/16/ecc2165ba2b738a1e0a0e4097be7310b.jpg",
        tam: [
            { ml: 50, price: 975, oldPrice: 850, image: "https://www.rhodeskin.com/cdn/shop/files/glaze-hero-desktop-final_22b6370e-b990-45c1-9bdc-fbbd938aaaaf_2480x.jpg?v=1736980682", },
            { ml: 15 , price: 680, oldPrice: 580, image: "https://i.pinimg.com/736x/9f/9e/11/9f9e11013800892abac8f6c0205f857b.jpg", }, 
        ],
        skinType: ["Todos los tipos"], concerns: ["Niacinamida", "Mejora la luminosidad"],
        routine: "Hidrata,ilumina & rellena visiblemente la piel"
    },
    /*{ id: "s15", name: "", 
        brand: "", category: "", stock: false, ss:false,
        image: "",
        tam: [
            { ml: 1, price: 1, oldPrice: 1, image: "", },
            { ml: 1 , price: 1, oldPrice: 1, image: "", }, 
        ],
        skinType: [""], concerns: ["", ""],
        routine: ""
    },
    { id: "s16", name: "", 
        brand: "", category: "", stock: false, ss:false,
        image: "",
        tam: [
            { ml: 1, price: 1, oldPrice: 1, image: "", },
            { ml: 1 , price: 1, oldPrice: 1, image: "", }, 
        ],
        skinType: [""], concerns: ["", ""],
        routine: ""
    },*/
    { id: "s17", name: "Barrier Restore Cream", 
        brand: "Rhode", category: "Hidratante", stock: false, ss:true,
        image: "https://www.rhodeskin.com/cdn/shop/files/brc-hero-d-2_2480x.jpg?v=1737658137",
        tam: [
            { ml: 50, price: 975, oldPrice: 850, image: "", },
            { ml: 30 , price: 680, oldPrice: 580, image: "https://i.pinimg.com/736x/b2/61/0d/b2610d224cd8a0b68708f136aa99be91.jpg", }, 
        ],
        skinType: ["Todos los tipos"], concerns: ["Hidrata profundamente", "Mejora la opacidad","Peptidos"],
        routine: "Crema para nutrir la barrera cutánea"
    },
    /*{ id: "s18", name: "", 
        brand: "", category: "", stock: false, ss:false,
        image: "",
        tam: [
            { ml: 1, price: 1, oldPrice: 1, image: "", },
            { ml: 1 , price: 1, oldPrice: 1, image: "", }, 
        ],
        skinType: [""], concerns: ["", ""],
        routine: ""
    },*/
    { id: "s19", name: "Gel Cleanser + Makeup Remover", 
        brand: "Tower 28", category: "Limpiadores", stock: false, ss:true,
        image: "https://www.tower28beauty.com/cdn/shop/files/SOSCLEANSER-PACKSHOT_2fda86f3-024f-4c61-aefa-455d5a9c7286.webp?v=1762200697&width=1800",
        tam: [
            { ml: 148, price: 640, oldPrice: 500, image: "", },
        ],
        skinType: ["Todos los tipos"], concerns: ["Remueve maquillaje,SPF,Sebo", "No irrita"],
        routine: "Limpiador facial"
    },
    { id: "s20", name: "Jet Lag Mask", 
        brand: "Summer Fridays", category: "Mask", stock: false, ss:true,
        image: "https://www.sephora.com/productimages/sku/s2473361-av-10-zoom.jpg?imwidth=1224",
        tam: [
            { ml: 28, price: 850, oldPrice: 740, image: "https://www.sephora.com/productimages/sku/s2473379-main-zoom.jpg?imwidth=1224", },
            { ml: 64 , price: 1370, oldPrice: 1190, image: "https://www.sephora.com/productimages/sku/s2473361-main-zoom.jpg?imwidth=1224", }, 
        ],
        skinType: ["Piel seca, mixta y sensible"], concerns: ["Brinda hidratación inmediata"],
        routine: "Mascarilla hidratante diaria"
    },
    { id: "s21", name: "Glazing Mist Face Spray", 
        brand: "Rhode", category: "Hidratante", stock: false, ss:true,
        image: "https://www.rhodeskin.com/cdn/shop/files/mist-hero-desktop-1_2480x.jpg?v=1748968212",
        tam: [
            { ml: 80, price: 980, oldPrice: 860, image: "", },
            { ml: 30, price: 680, oldPrice: 580, image: "https://i.pinimg.com/736x/69/d1/ae/69d1ae146e94839529c3a92db75cd9e3.jpg", }, 
        ],
        skinType: ["Todos los tipos"], concerns: ["Beta-glucan", "Trio Ceramidas","Ilumina"],
        routine: "Bruma que hidrata, refresca e ilumina"
    },
    { id: "s22", name: "Barrier Butter Balm", 
        brand: "Rhode", category: "Hidratante", stock: false, ss:true,
        image: "https://i.pinimg.com/736x/0c/a5/68/0ca568f18318cb2388b227f1a52365b5.jpg",
        tam: [
            { ml: 100, price: 1060, oldPrice: 950, image: "", },
            { ml: 40 , price: 700, oldPrice: 600, image: "https://i.pinimg.com/736x/2d/f6/fd/2df6fd59a5601f106ac7492d7eaae0fc.jpg", }, 
        ],
        skinType: ["Normal y seca"], concerns: ["reduce apariencia de líneas de expresión"],
        routine: "Hidratación profunda y ayuda a retener la humedad"
    },
    { id: "s23", name: "SOS Skin Barrier Cream ", 
        brand: "Tower 28", category: "Hidratante", stock: false, ss:true,
        image: "https://www.tower28beauty.com/cdn/shop/files/Group_4147.jpg?v=1752712753&width=1800",
        tam: [
            { ml: 20, price: 500, oldPrice: 420, image: "https://www.sephora.com/productimages/sku/s2892933-main-zoom.jpg?imwidth=1224", },
            { ml: 55 , price: 690, oldPrice: 620, image: "https://www.sephora.com/productimages/sku/s2675510-main-zoom.jpg?imwidth=1224", }, 
            { ml: 100 , price: 995, oldPrice: 885, image: "https://www.sephora.com/productimages/sku/s2842987-main-zoom.jpg?imwidth=1224", }, 
        ],
        skinType: ["Todas, preferentemente Pieles sensibles"], concerns: ["Refuerza la barrera cutánea", "Hidrata & calma"],
        routine: "Para recuperación de barrera cutánea y enrojecimiento"
    },
    { id: "s24", name: "SOS Intensive Serum", 
        brand: "Tower 28", category: "Serum", stock: false, ss:true,
        image: "https://www.sephora.com/productimages/sku/s2879856-main-zoom.jpg?imwidth=1224",
        tam: [
            { ml: 59.2, price: 960, oldPrice: 860, image: "", },
        ],
        skinType: ["Todas, Preferentemente piel sensible"], concerns: ["Acné e imperfecciones", "enrojecimiento"],
        routine: "Sérum ácido hipocloroso para calmar y tratar la piel"
    },
    { id: "s25", name: "Caffeine Reset Cream Mask", 
        brand: "Rhode", category: "", stock: false, ss:true,
        image: "https://www.rhodeskin.com/cdn/shop/files/caffeine-reset-hero4-desktop_9e4a29d8-538d-4a39-9b10-d7b59e05252b_2480x.jpg?v=1769815881",
        tam: [ { ml: 50, price: 1080, oldPrice: 920, image: "", }, ],
        skinType: ["Todos los tipos"], concerns: ["Desinflama la piel", "Hidrata"],
        routine: "Crema con cafeína que reduce la hinchazón"
    },
];